export default "__VITE_ASSET__BPraECZp__"